export enum ReducerTypes {
  fetchChallenges = "fetchChallenges",
  setChallengeFilter = "setChallengeFilter",
  setPathFilter = "setPathFilter",
  setLevelFilter = "setPathFilter",
  fetchSolutions = "fetchSolutions",
  appendSolutions = "appendSolutions",
  setSolutionPage = "setSolutionPage",
  startFetchingUser = "startFetchingUser",
  endFetchingUser = "endFetchingUser",
  getUser = "get_user",
  getUserSolutions = "getUserSolutions",
  removeUser = "removeUser",
  startGlobalLoader = "startGlobalLoader",
  endGlobalLoader = "endGlobalLoader",
  reset = "reset",
  resetUser = "resetUser",
  sessionExpired = "sessionExpired",
  unexpectedError = "unexpectedError",
  clearError = "clearError",
  requireLogin = "requireLogin",
  getNotification = "getNotification",
  setNotification = "setNotification",
  seenNotifications = "seenNotifications",
  getUserBadges = "getUserBadges",
  getRecentBadges = "getRecentBadges",
  getTopUsers = "getTopUsers",
  getTheme = "getTheme",
  setSolutionsCurrentPage = "setSolutionsCurrentPage",
  setSolutions = "setSolutions",
  setSolutionsEnd = "setSolutionsEnd",
  setSolutionsLoading = "setSolutionsLoading",
  setSelectedChallangeId = "setSelectedChallangeId",
  setSelectedChallange = "setSelectedChallange",
}
